import { useContextOrThrow } from '@deephaven/react-hooks';
import { ConnectionContext } from "./ConnectionContext.js";
/**
 * Retrieve the connection for the current context.
 *
 * @returns Connection for the current context
 */
export function useConnection() {
  return useContextOrThrow(ConnectionContext, 'No IdeConnection available in useConnection. Was code wrapped in ConnectionContext.Provider?');
}
export default useConnection;
//# sourceMappingURL=useConnection.js.map